// /admin sits outside the AuthenticationGuard, so the client has no token
// configured and the admin token must be attached per request.
export const adminAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("admin-token")}`,
});
